module.exports = __webpack_public_path__ + "img/20240718_162959.0a6b1b1c.jpg";